import axios from "axios";

export const API = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });
export const errMsg = (e) => e?.response?.data?.detail || "Something went wrong. Please try again.";
